import {
  createSlice,
  createSelector,
  createAsyncThunk,
} from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";
import { createWrapper } from "main/features/AxiosWrapper";
import { AccountParam, AccountParamState } from "main/types/accountParam";
import { ErrorResponse } from "main/types/errorResponse";
import {
  isPendingAction,
  isRejectedAction,
  isFulfilledAction,
  deepMerge,
} from "main/utils/sliceUtil";
import { API_BASE_PATH } from "main/constants/constant";
import { RootState } from "main/store";

const key = "accountParam";

const initialState: AccountParamState = {
  accountParam: null,
  error: null,
  loading: false,
};

/** Async * */
export const fetchAccountParam = createAsyncThunk<
  AccountParam,
  {
    hotelId: string | string[];
    headers?: any;
    locale?: string;
    isServerSide?: boolean;
  },
  {
    rejectValue: ErrorResponse;
  }
>(`${key}/fetchAccountParam`, async (args, { rejectWithValue }) => {
  try {
    const { hotelId, headers, isServerSide, locale } = args;
    const url = `${API_BASE_PATH}/v1/hotels/${hotelId}/account_params`;
    const result = await createWrapper({ isServerSide, locale }).get(url, {
      headers,
    });
    return result.data;
  } catch (err) {
    return rejectWithValue(err.data.errors);
  }
});

/** slice * */
export const accountParamSlice = createSlice({
  name: key,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(HYDRATE, (state, action: any) => {
        const accountParam = deepMerge(state, action.payload.accountParam);
        return { ...state, ...accountParam };
      })
      .addCase(fetchAccountParam.fulfilled, (state, action) => {
        state.accountParam = action.payload;
      })
      // 一旦slice単位で共通化
      .addMatcher(isPendingAction(key), (state) => {
        state.loading = true;
      })
      .addMatcher(isFulfilledAction(key), (state) => {
        state.loading = false;
      })
      .addMatcher(isRejectedAction(key), (state, action: any) => {
        state.error = action.payload?.error_messages;
        state.loading = false;
      });
  },
});

/** selector * */
const stateSelector = (state: RootState) => state[key];

export const hotelPageLiffIdSelector = createSelector(
  stateSelector,
  (state) => state.accountParam?.hotelPageLiffId,
);

export const checkInPageLiffIdSelector = createSelector(
  stateSelector,
  (state) => state.accountParam?.checkInPageLiffId,
);

export const loadingSelector = createSelector(
  stateSelector,
  (state) => state.loading,
);

// action export
